import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  AlertController,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonTitle,
  IonToolbar,
  LoadingController,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FileDropAreaComponent } from '@okcargo-apps/layout-ionic';
import { DecaMutationsService } from '../deca-mutations.service';

@Component({
  selector: 'lib-deca-upload-file-documents-modal',
  templateUrl: './deca-upload-file-documents-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonFooter,
    IonRow,
    IonGrid,
    IonContent,
    IonCol,
    IonTitle,
    IonIcon,
    IonButton,
    IonButtons,
    IonToolbar,
    IonHeader,
    FileDropAreaComponent,
    TranslateModule,
  ],
})
export class DecaUploadFileDocumentsModalComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly loadingCtrl = inject(LoadingController);
  private readonly alertCtrl = inject(AlertController);
  private readonly translate = inject(TranslateService);
  private readonly decaMutationsService = inject(DecaMutationsService);

  private selectedDocument: File | null = null;

  public errorMessage = signal<string | null>(null);

  public async uploadCompanyDocumentAsFile(file: File): Promise<void> {
    this.selectedDocument = file;
  }

  public async confirm(): Promise<void> {
    if (this.selectedDocument) {
      const loading = await this.loadingCtrl.create({
        message: this.translate.instant('general.send_data'),
      });
      await loading.present();

      try {
        const result = await this.decaMutationsService.uploadFile(this.selectedDocument);
        this.modalCtrl.dismiss(result, 'confirm');
      } catch (error) {
        this.errorMessage.set(this.translate.instant('error.send_form'));
      } finally {
        await loading.dismiss();
      }
    } else {
      this.errorMessage.set(this.translate.instant('error.empty_file'));
    }
  }

  public async closeModalWithCancel(): Promise<boolean> {
    if (this.selectedDocument) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('general.confirm'),
        message: this.translate.instant('general.close_without_save_msg'),
        buttons: [
          {
            text: this.translate.instant('general.cancel'),
            role: 'cancel',
            handler: () => {
              // do nothing
            },
          },
          {
            text: this.translate.instant('general.close_without_save'),
            role: 'confirm',
            handler: () => {
              this.modalCtrl.dismiss(null, 'cancel');
            },
          },
        ],
      });
      await alert.present();
      return false;
    } else {
      return this.modalCtrl.dismiss(null, 'cancel');
    }
  }

  // TODO download example file!!!!
}
